import { useState, useRef, useCallback } from 'react';

interface TesterCommentProps {
  messageIndex: number;
  existingComment?: string;
  onSave: (messageIndex: number, kommentar: string) => void;
}

export function TesterComment({ messageIndex, existingComment, onSave }: TesterCommentProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(existingComment || '');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const autoResize = useCallback(() => {
    const ta = textareaRef.current;
    if (ta) {
      ta.style.height = 'auto';
      ta.style.height = ta.scrollHeight + 'px';
    }
  }, []);

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSave(messageIndex, trimmed);
    setIsEditing(false);
  };

  if (existingComment && !isEditing) {
    return (
      <div className="tester-note">
        <span className="tester-note-icon">📝</span>
        <span className="tester-note-text">{existingComment}</span>
        <button
          className="tester-note-edit"
          onClick={() => { setText(existingComment); setIsEditing(true); }}
        >
          ✏️
        </button>
      </div>
    );
  }

  if (isEditing) {
    return (
      <div className="tester-form">
        <textarea
          ref={textareaRef}
          className="tester-input"
          value={text}
          onChange={(e) => { setText(e.target.value); autoResize(); }}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSubmit(); } }}
          placeholder="Kommentar eingeben..."
          rows={1}
          autoFocus
          onFocus={autoResize}
        />
        <button className="tester-save" onClick={handleSubmit}>Speichern</button>
        <button className="tester-cancel" onClick={() => setIsEditing(false)}>Abbrechen</button>
      </div>
    );
  }

  return (
    <button
      className="tester-pen"
      onClick={() => setIsEditing(true)}
      title="Kommentar hinzufügen"
    >
      ✏️
    </button>
  );
}
